import { SVGS } from '@zonofi/zono-money-design-system';
import React from 'react';
import './product-details-header.scss';
import { CartIcon } from '../cart-icon/cart-icon';
import { useNavigate, useSearchParams } from 'react-router-dom';

interface ProductDetailsHeaderProps {
  productName?: string;
  totalCartItems: number;
  info?: { showIcon: boolean; onClick: () => void };
}
export const ProductDetailsHeader: React.FC<ProductDetailsHeaderProps> = ({
  productName,
  totalCartItems,
  info,
}) => {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  return (
    <div className="product-details-header">
      <div
        className="left-content"
        style={{ width: info?.showIcon ? '82%' : '88%' }}
      >
        <div
          className="back-button"
          onClick={() => {
            navigate(-1);
          }}
        >
          <img
            src={SVGS.LeftArrowBlack}
            alt="back"
            width={'20px'}
            height={'20px'}
            onClick={() => navigate(-1)}
          />
        </div>
        <div className="product-name font-primary-medium" title={productName}>
          {productName}
        </div>
      </div>
      <div className="right-content">
        {info?.showIcon && (
          <img
            src={SVGS.InfoIconBlack}
            alt=""
            className="info-icon"
            onClick={() => {
              info?.onClick();
            }}
            width={28}
            height={28}
          />
        )}
        {params?.get('hideAddToCart') !== 'true' && (
          <CartIcon
            itemsCount={totalCartItems}
            onCartClick={() => {
              navigate('/cart');
            }}
          />
        )}
      </div>
    </div>
  );
};
